/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Csv_To_Json_Deep_P2Inputs */

const en_csv_to_json_deep_p2 = /** @type {(inputs: Csv_To_Json_Deep_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consider what type guessing costs. A postal code column containing 07030 becomes the number 7030 and the leading zero is gone. A part number like 1E5 becomes 100000 in scientific notation. An identifier of twenty digits gets rounded past the sixteenth. A column of version strings where one row reads 1.10 becomes 1.1. Each of these is a silent, irreversible change to a value that looked like a number but was not one.`)
};

const ko_csv_to_json_deep_p2 = /** @type {(inputs: Csv_To_Json_Deep_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`타입 추측의 대가를 생각해보세요. 07030을 담은 우편번호 열은 숫자 7030이 되고 앞의 0이 사라집니다. 1E5 같은 부품 번호는 과학적 표기로 100000이 됩니다. 스무 자리 식별자는 열여섯 번째 자리 뒤가 반올림됩니다. 한 행이 1.10인 버전 문자열 열은 1.1이 됩니다. 이들 각각은 숫자처럼 보였지만 숫자가 아니었던 값에 대한, 조용하고 되돌릴 수 없는 변경입니다.`)
};

const ja_csv_to_json_deep_p2 = /** @type {(inputs: Csv_To_Json_Deep_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`型推測の代償を考えてください。07030 を含む郵便番号の列は数値 7030 になり先頭のゼロが消えます。1E5 のような部品番号は科学表記で 100000 になります。20 桁の識別子は 16 桁目より後が丸められます。ある行が 1.10 のバージョン文字列の列は 1.1 になります。これらはいずれも、数値のように見えて数値ではなかった値に対する、静かで取り返しのつかない変更です。`)
};

/**
* | output |
* | --- |
* | "Consider what type guessing costs. A postal code column containing 07030 becomes the number 7030 and the leading zero is gone. A part number like 1E5 becomes..." |
*
* @param {Csv_To_Json_Deep_P2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const csv_to_json_deep_p2 = /** @type {((inputs?: Csv_To_Json_Deep_P2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Csv_To_Json_Deep_P2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_csv_to_json_deep_p2(inputs)
	if (locale === "ko") return ko_csv_to_json_deep_p2(inputs)
	return ja_csv_to_json_deep_p2(inputs)
});